<template>
  <div class="Tem485" style="height: 100%;background:#fff;margin-bottom:32px;">
    <el-row :gutter="40">
      <el-col :lg="8" :sm="8" :xs="8" class="card-panel-col">
        <div class="infoContentWarp">
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.TotalCurrent') }}：</span>
            <span class="val">{{ info477.totalCurr }} A</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.TotalVoltage') }}：</span>
            <span class="val">{{ info477.totalVol }} V</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">SOC：</span>
            <span class="val">{{ info477.soc }} %</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">SOH：</span>
            <span class="val">{{ info477.soh }} %</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('yhubReport.MaximumTemperature') }}：</span>
            <span class="val">{{ info477.maxTemp }} {{ unit }}</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.highTemInNo') }}：</span>
            <span class="val">{{ info477.maxTempInterNo }} </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.MaxTemModNo') }}：</span>
            <span class="val">{{ info477.maxTempModuleNo }} </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('yhubReport.MinTemp') }}：</span>
            <span class="val">{{ info477.minTemp }} {{ unit }}</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.LowTemInNo') }}：</span>
            <span class="val">{{ info477.minTempInterNo }} </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.LowTemModNo') }}：</span>
            <span class="val">{{ info477.minTempModuleNo }} </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.WarnGrade') }}：</span>
            <span v-if="info477.almLv==1" class="val">{{ $t('eveF477.WarnGrade1') }} </span>
            <span v-else-if="info477.almLv==2" class="val">{{ $t('eveF477.WarnGrade2') }} </span>
            <span v-else-if="info477.almLv==3" class="val">{{ $t('eveF477.WarnGrade3') }} </span>
            <span v-else class="val">-- </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.No') }}：</span>
            <span class="val">{{ info477.cycleIndex }} </span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('eveF477.BMSAddress') }}：</span>
            <span class="val">{{ info477.bmsId }} </span>
          </div>
        </div>
      </el-col>
      <el-col :lg="16" :sm="16" :xs="16" class="card-panel-col" style="border-left: 1px solid #DCDFE6;">
        <div class="card-panel" style="height:400px;">
          <p class="blockTitleP">
            <i class="el-icon-time" style="font-size: 24px;" />
            <span style="vertical-align: top;"> {{ timeAgo }}</span>
            <el-button icon="el-icon-download" style="vertical-align: top;margin:0 10px;float: right;position: relative;z-index: 999;" type="primary" @click="download" />
          </p>
          <div class="iconContentWarp">
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.MaxCellV') }}(V) ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in maxCellVoltList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<maxCellVoltList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.highCellVInNo') }} ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in maxCellVoltInterNoList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<maxCellVoltInterNoList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.highCellVModNo') }} ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in maxCellVoltModuleNoList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<maxCellVoltModuleNoList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.LowestCellV') }}(V) ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in minCellVoltList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<minCellVoltList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.LowestCellVInNo') }} ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in minCellVoltInterNoList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<minCellVoltInterNoList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="envTemIconWarp oneWarp">
              <div class="oneName">
                {{ $t('eveF477.lowCellVInNo') }} ：
              </div>
              <div class="oneIconDiv">
                <div v-for="(item,index) in minCellVoltModuleNoList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }}</p>
                  <el-divider v-if="index<minCellVoltModuleNoList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

    </el-row>

    <!-- 下载时间选择--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" min-width="60%">
      <el-row class="tableWarp" style="margin-top: -20px;text-align: center;">
        <div v-if="!isDownloading">
          <el-date-picker v-model="selectDay" type="date" :placeholder="$t('location.pleaseSelectDate')" />
          <div class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="isShowPop = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitPop">{{ $t('button.Confirm') }}</el-button>
          </div>
        </div>
        <p v-else>{{ $t('button.Downloading') }}</p>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>

import { howLongAgo } from '@/utils/updateTime.js'
import { lastMsgFP477Data } from '@/api/allDevice'
import i18n from '@/i18n'
import { temChange, temUnit } from '@/utils/temChange.js'

export default {
  components: {
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    },
    sn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      yhubmqtt: {},
      timer: null,
      timeAgo: i18n.t('dataAndTime.AMomentAgo'),
      timeAgoRST: new Date().getTime(),
      maxCellVoltList: [],
      maxCellVoltInterNoList: [],
      maxCellVoltModuleNoList: [],
      minCellVoltList: [],
      minCellVoltInterNoList: [],
      minCellVoltModuleNoList: [],
      info477: {
        almLv: null,
        bmsId: null,
        cycleIndex: null,
        maxTemp: null,
        maxTempInterNo: null,
        maxTempModuleNo: null,
        minTemp: null,
        minTempInterNo: null,
        minTempModuleNo: null,
        soc: null,
        soh: null,
        totalCurr: null,
        totalVol: null
      },
      selectDay: new Date().getTime(),
      isShowPop: false,
      isDownloading: false, // 是否在下载中
      unit: '℃'

    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (this.timeAgoRST) { this.timeAgo = ''; this.timeAgo = howLongAgo(this.timeAgoRST) }
    },
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    this.unit = temUnit()
    setTimeout(() => {
      this.queryList()
    }, 50)
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) this.timeAgo = howLongAgo(this.timeAgoRST)
        }, 60000)
      }
    },
    queryList() {
      lastMsgFP477Data({ mcuId: this.mcuId }).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) {
          this.maxCellVoltList = this.maxCellVoltInterNoList = this.maxCellVoltModuleNoList = this.minCellVoltList = this.minCellVoltInterNoList = this.minCellVoltModuleNoList = []
          for (var attr in this.info477) {
            this.info477[attr] = '--'
          }
          this.timeAgoRST = null
          this.timeAgo = howLongAgo(this.timeAgoRST)
        } else {
          this.info477 = res.resultModel
          for (var attr in this.info477) {
            if (!this.info477[attr] && this.info477[attr] != 0) this.info477[attr] = '--'
          }
          this.info477.totalCurr = res.resultModel.totalCurr || res.resultModel.totalCurr == 0 ? res.resultModel.totalCurr / 10 : '--'
          this.info477.totalVol = res.resultModel.totalVol || res.resultModel.totalVol == 0 ? res.resultModel.totalVol / 10 : '--'
          this.info477.maxTemp = temChange(this.info477.maxTemp)
          this.info477.minTemp = temChange(this.info477.minTemp)
          this.timeAgoRST = res.resultModel.yhubTime
          this.timeAgo = howLongAgo(this.timeAgoRST)
          this.maxCellVoltList = this.setData(JSON.parse(res.resultModel.maxCellVolt), 1000)
          this.maxCellVoltInterNoList = this.setData(JSON.parse(res.resultModel.maxCellVoltInterNo), 1)
          this.maxCellVoltModuleNoList = this.setData(JSON.parse(res.resultModel.maxCellVoltModuleNo), 1)
          this.minCellVoltList = this.setData(JSON.parse(res.resultModel.minCellVolt), 1000)
          this.minCellVoltInterNoList = this.setData(JSON.parse(res.resultModel.minCellVoltInterNo), 1)
          this.minCellVoltModuleNoList = this.setData(JSON.parse(res.resultModel.minCellVoltModuleNo), 1)
        }
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuId) == -1) return
        if (this.yhubmqtt) {
          if (this.yhubmqtt.payload === 'mCan') {
            if (this.yhubmqtt.mCan && this.yhubmqtt.mCan.payload === 'mFP477Data') {
              console.log('MQTT===mFP477Data==', this.yhubmqtt.mCan.mFP477Data)
              var enData = this.yhubmqtt.mCan.mFP477Data || {}
              var newEnData = {}
              for (var attr in enData) {
                var newAttr = attr[0].toLowerCase() + attr.slice(1)
                newEnData[newAttr] = enData[attr]
              }
              for (var attr in newEnData) {
                this.info477[attr] = newEnData[attr]
              }
              this.info477.totalCurr = newEnData.totalCurr || newEnData.totalCurr == 0 ? newEnData.totalCurr / 10 : '--'
              this.info477.totalVol = newEnData.totalVol || newEnData.totalVol == 0 ? newEnData.totalVol / 10 : '--'
              this.info477.maxTemp = temChange(this.info477.maxTemp)
              this.info477.minTemp = temChange(this.info477.minTemp)
              this.timeAgoRST = newEnData.yhubTime
              this.timeAgo = howLongAgo(this.timeAgoRST)
              this.maxCellVoltList = this.setData(newEnData.maxCellVolt, 1000)
              this.maxCellVoltInterNoList = this.setData(newEnData.maxCellVoltInterNo, 1)
              this.maxCellVoltModuleNoList = this.setData(newEnData.maxCellVoltModuleNo, 1)
              this.minCellVoltList = this.setData(newEnData.minCellVolt, 1000)
              this.minCellVoltInterNoList = this.setData(newEnData.minCellVoltInterNo, 1)
              this.minCellVoltModuleNoList = this.setData(newEnData.minCellVoltModuleNo, 1)
            }
          }
        }
      }
    },
    download() { // 下载--打开弹窗
      this.isShowPop = true
    },
    submitPop() { // 下载--确定下载
      this.isDownloading = true
      var param = {
        mcuId: this.$route.query.mcuId,
        sn: this.sn,
        startDate: new Date().setHours(0, 0, 0, 0), // 一周开始时间
        endDate: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000 // 今天23:59:59
      }
      if (this.selectDay) {
        param.startDate = new Date(this.selectDay).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportMsgFP477Data?mcuId='
      url += param.mcuId + '&sn=' + param.sn + '&startDate=' + param.startDate + '&endDate=' + param.endDate
      window.open(url, '_bank')
      setTimeout(() => {
        this.isDownloading = this.isShowPop = false
      }, 3000)
    },
    setData(arr, num,) {
      var newArr = []
      arr.forEach(v => {
        var newVal = v / num
        var str = newVal.toString()
        if (str.indexOf('.') > -1 && str.split('.')[1].length > 2) {
          newVal = newVal.toFixed(2)
        }
        newArr.push(newVal)
      })
      return newArr
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.Tem485{
  .iconContentWarp{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 310px;
    .oneWarp{
      display: flex;
      margin-bottom: 5px;
      align-items: center;
      width: calc(100% - 20px);
      border-bottom: 1px solid #DCDFE6;
    }
    .oneIconDiv{
      display: flex;
      // width: calc(100% - 140px);
      overflow-x: auto;
      p{
        white-space: nowrap;
      }
    }
    .oneAttrBox{
      display: flex;
      margin: 10px 0;
      width:55px;
      justify-content: space-between;
    }
    .el-divider--vertical{
      margin:0 13px;
    }
    .iconBox{
      width: 100px;
      // border:1px solid red;
      display: flex;
      justify-content: center;
    }
  }
  .infoContentWarp{
    margin: 0px;
    background:#fff;
    height:400px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px;
  }
  .el-input {
    width: 60% !important;
  }
  .oneName{
    text-overflow: ellipsis;
    white-space: nowrap;
    width:200px;
  }
}
</style>

